/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteAnnotationFragment = { __typename: 'Annotation', id: string, title?: string | null, body: string, severity: Types.AnnotationSeverity, validFrom: any, validUntil?: any | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string } };

export type AddQuoteAnnotationMutationVariables = Types.Exact<{
  input: Types.AddQuoteAnnotationInput;
}>;


export type AddQuoteAnnotationMutation = { addQuoteAnnotation: { __typename: 'Annotation', id: string, title?: string | null, body: string, severity: Types.AnnotationSeverity, validFrom: any, validUntil?: any | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string } } };

export type DiscardQuoteAnnotationMutationVariables = Types.Exact<{
  input: Types.DiscardQuoteAnnotationInput;
}>;


export type DiscardQuoteAnnotationMutation = { discardQuoteAnnotation: { __typename: 'Annotation', id: string, title?: string | null, body: string, severity: Types.AnnotationSeverity, validFrom: any, validUntil?: any | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string } } };

export const QuoteAnnotationFragmentDoc = gql`
    fragment QuoteAnnotation on Annotation {
  id
  title
  body
  severity
  validFrom
  validUntil
  createdAt
  createdBy {
    id
    firstname
    familyname
  }
}
    `;
export const AddQuoteAnnotationDocument = gql`
    mutation AddQuoteAnnotation($input: AddQuoteAnnotationInput!) {
  addQuoteAnnotation(input: $input) {
    ...QuoteAnnotation
  }
}
    ${QuoteAnnotationFragmentDoc}`;
export type AddQuoteAnnotationMutationFn = Apollo.MutationFunction<AddQuoteAnnotationMutation, AddQuoteAnnotationMutationVariables>;

/**
 * __useAddQuoteAnnotationMutation__
 *
 * To run a mutation, you first call `useAddQuoteAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuoteAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuoteAnnotationMutation, { data, loading, error }] = useAddQuoteAnnotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuoteAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<AddQuoteAnnotationMutation, AddQuoteAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuoteAnnotationMutation, AddQuoteAnnotationMutationVariables>(AddQuoteAnnotationDocument, options);
      }
export type AddQuoteAnnotationMutationHookResult = ReturnType<typeof useAddQuoteAnnotationMutation>;
export type AddQuoteAnnotationMutationResult = Apollo.MutationResult<AddQuoteAnnotationMutation>;
export type AddQuoteAnnotationMutationOptions = Apollo.BaseMutationOptions<AddQuoteAnnotationMutation, AddQuoteAnnotationMutationVariables>;
export const DiscardQuoteAnnotationDocument = gql`
    mutation DiscardQuoteAnnotation($input: DiscardQuoteAnnotationInput!) {
  discardQuoteAnnotation(input: $input) {
    ...QuoteAnnotation
  }
}
    ${QuoteAnnotationFragmentDoc}`;
export type DiscardQuoteAnnotationMutationFn = Apollo.MutationFunction<DiscardQuoteAnnotationMutation, DiscardQuoteAnnotationMutationVariables>;

/**
 * __useDiscardQuoteAnnotationMutation__
 *
 * To run a mutation, you first call `useDiscardQuoteAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardQuoteAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardQuoteAnnotationMutation, { data, loading, error }] = useDiscardQuoteAnnotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardQuoteAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<DiscardQuoteAnnotationMutation, DiscardQuoteAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardQuoteAnnotationMutation, DiscardQuoteAnnotationMutationVariables>(DiscardQuoteAnnotationDocument, options);
      }
export type DiscardQuoteAnnotationMutationHookResult = ReturnType<typeof useDiscardQuoteAnnotationMutation>;
export type DiscardQuoteAnnotationMutationResult = Apollo.MutationResult<DiscardQuoteAnnotationMutation>;
export type DiscardQuoteAnnotationMutationOptions = Apollo.BaseMutationOptions<DiscardQuoteAnnotationMutation, DiscardQuoteAnnotationMutationVariables>;